import { AnyAction } from "redux";
import actions from "../../util/actions";
import { AppReducerState } from "../../interfaces";

const initialState: AppReducerState = {
  initial: false,
  loading: true,
  error: null,
  response: null
};

const reducer = (state = initialState, action: AnyAction): AppReducerState => {
  switch (action.type) {
    case actions.APP_HTTP_LOADING:
      return { ...state, response: null, loading: true, error: null };
    case actions.APP_HTTP_ERROR:
      if (action.payload.clear) {
        return { ...state, response: null, loading: false, error: null };
      }
      return { ...state, response: null, loading: false, error: { ...action.payload } };
    case actions.APP_HTTP_COMPLETE:
      return { ...state, initial: true, response: action.payload.response, loading: false, error: null };
    default:
      return state;
  }
};

export default reducer;
